import { mbaHighlights } from "./constant";
import "../../shared/styles/index.css";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { CreateStudentEnquirey } from "../../api/Global";

const Institute_Highlights = () => {
  const [showMoreContent, setShowMoreContent] = useState(false);

  
    const navigate = useNavigate();
    const closeModal = () => setShowModal(false);
    const openModal = () => setShowModal(true);
  
    const [name, setName] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [city, setCity] = useState("");
    const [course, setCourse] = useState("");
    const [mathAnswer, setMathAnswer] = useState("");
    const [show, setShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
  
    const [nameError, setNameError] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [cityError, setCityError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [courseError, setCourseError] = useState("");
    const [sumAnswerError, setsumAnswerError] = useState("");
  
    const HandleSubmit = async (e) => {
      e.preventDefault();
  
      setNameError("");
      setMobileError("");
      setCityError("");
      setEmailError("");
      setCourseError("");
      setsumAnswerError("");
  
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const indianMobileRegex = /^[6-9]\d{9}$/;
  
      if (!name.trim()) return setNameError("Name is required!");
  
      if (!email.trim()) return setEmailError("Email is required!");
      if (!emailRegex.test(email.trim()))
        return setEmailError(
          "Please provide a correct email, invalid email format!"
        );
  
      if (!mobile.trim()) return setMobileError("Mobile number is required!");
      if (!indianMobileRegex.test(mobile.trim()))
        return setMobileError("Invalid mobile number format");
      if (!city.trim()) return setCityError("City is required!");
  
      if (!course.trim()) return setCourseError("Course is required!");
  
      if (!mathAnswer.trim()) return setsumAnswerError("Please add the sum!");
      if (mathAnswer.toString() !== "14")
        return setsumAnswerError("Please add and put the correct value");
      const data = {
        name,
        email,
        mobile,
        email,
        city,
        course,
        mathAnswer,
      };
      try {
        const response = await CreateStudentEnquirey(data);
  
        if (response?.data?.status == true) {
          navigate("/Thank_You");
          setName("");
          setEmail("");
          setMobile("");
          setCity("");
          setCourse("");
          setMathAnswer("");
          setShow(false);
        }
      } catch (error) {
        console.error("error", error);
      }
    };

  const handleShowContent = () => {
    setShowMoreContent(!showMoreContent);
  };

  return (
    <div className="institute-highlight-container">
       {/*  modal code [admission form] */}

      <Modal
        size="lg"
        className="asmission_enquiry"
        show={showModal}
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="text-center"
            style={{
              textAlign: "center",
              width: "100%",
              color: "#007bff",
            }}
          >
            Admission Enquiry Form
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-white p-2 p-lg-5">
            <div className="modlaPopup">
              <div className="elementor-widget-container">
                <form className="wpcf7-form">
                  <div className="form-group mb-3">
                    <label>Your Name</label>
                    <input
                      className="form-control"
                      placeholder="Name"
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      name="name"
                      value={name}
                    />
                    {nameError && <p className="text-danger">{nameError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Your Email</label>
                    <input
                      className="form-control"
                      placeholder="Email ID"
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      name="email"
                      value={email}
                    />
                    {emailError && <p className="text-danger">{emailError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Mobile Number</label>
                    <input
                      className="form-control"
                      placeholder="Phone"
                      onChange={(e) => setMobile(e.target.value)}
                      type="number"
                      name="mobile"
                      value={mobile}
                    />
                    {mobileError && (
                      <p className="text-danger">{mobileError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>City</label>
                    <input
                      className="form-control"
                      placeholder="City"
                      onChange={(e) => setCity(e.target.value)}
                      type="text"
                      name="city"
                      value={city}
                    />
                    {cityError && <p className="text-danger">{cityError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Course</label>
                    <select
                      className="form-control"
                      required
                      name="course"
                      value={course}
                      onChange={(e) => setCourse(e.target.value)}
                    >
                      <option value="">Please select Any Course</option>
                      <option value="B.Tech. Courses[CS,IT,AI & DS,CSIT]">
                        Engineering Courses [CS, IT, AI & DS, CSIT]
                      </option>
                      <option value="B.Tech. Course [EC]">
                        Engineering Course [Electronics & Comm. Engg.]
                      </option>
                      <option value="B.Tech. Course [ME]">
                        Engineering Course [Mechanical Engineering]
                      </option>
                      <option value="B.Tech. Course [Civil Engg.]">
                        Engineering Course [Civil Engineering]
                      </option>
                      <option value="Pharmacy Courses[B.Pharm, D.Pharm]">
                        Pharmacy Courses [B.Pharm, D.Pharm]
                      </option>
                      <option value="Pharmacy Course[M.Pharm]">
                        Pharmacy Course [M.Pharm]
                      </option>
                      <option value="Management Courses[MBA(FT,MM,FA)]">
                        Management Courses [MBA(FT,MM,FA)]
                      </option>
                      <option value="Professional Course [BBA]">
                        Professional Courses [BBA]
                      </option>
                      <option value="Professional Course[BCA]">
                        Professional Courses [BCA]
                      </option>
                      <option value="Professional Course[B.Com]">
                        Professional Courses [B.Com]
                      </option>
                      <option value="Law Courses(LLB Hons, BA LLB Hons, BBA LLB Hons)">
                        Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]
                      </option>
                      <option value="MCA Course">MCA Course</option>
                    </select>
                    {courseError && (
                      <p className="text-danger">{courseError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>What is nine plus five?</label>
                    <input
                      className="form-control"
                      placeholder="Answer"
                      onChange={(e) => setMathAnswer(e.target.value)}
                      type="text"
                      name="mathAnswer"
                      value={mathAnswer}
                    />
                    {sumAnswerError && (
                      <p className="text-danger">{sumAnswerError}</p>
                    )}
                  </div>
                  {/* 
                  <div className="form-group">
                    <div className="form-submit">
                      <button  type="button" onClick={HandleSubmit} className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div> */}

                  <div className="form-group mb-3 text-center">
                    <button
                      className="btn btn-primary w-100"
                      type="submit"
                      onClick={HandleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      <div className="institute-highlight-first-container">
        <h2 className="section-title-h2">
          Why CDGI is Among the Top Engineering Colleges in Indore
        </h2>
        <p className="section-description">
          CDGI combines academic rigor with practical exposure, modern
          facilities, and highly experienced faculty. Our curriculum is updated
          regularly to include emerging technologies, real-world project work,
          and industry collaboration.
        </p>
      </div>

      {showMoreContent && (
        <>
          <div className="institute-highlight-second-container">
            <h3 className="subsection-title-h3">Key Highlights </h3>
            <div className="mba-highlights-list">
              {mbaHighlights.map((highlight, ind) => (
                <p key={ind} className="highlight-item">
                  • {highlight}
                </p>
              ))}
            </div>
          </div>

          <div className="vision-container">
            <h2 className="section-title-h2">
              CDGI's Engineering Programs – B.Tech Courses
            </h2>

            <p className="vision-description">
              As one of the top engineering colleges in Indore, CDGI offers a
              wide range of B.Tech programs across various disciplines to help
              students align their passion with professional goals.
            </p>
          </div>

          <div className="mba-specializations-container">
            <div className="financial-administration-specialization">
              <Link to="/Overview/66e7f7154e3cc865577c318f/computer-science-and-engineering">
                <h3 className="subsection-title-h3 text-hover-blue-underline">
                  B.Tech in Computer Science & Engineering
                </h3>
              </Link>
              <p className="specialization-description">
                Our flagship program in Computer Science & Engineering focuses
                on software development, AI, machine learning, cybersecurity,
                and cloud computing. Students gain hands-on experience through
                coding labs, hackathons, and capstone projects.
              </p>

              <div className="course-highlights">
                <p className="highlight-heading">Course Features:</p>
                <p>• Full-Stack Development</p>
                <p>• AI & Machine Learning Modules</p>
                <p>• Cybersecurity Fundamentals</p>
                <p>• Database Management Systems</p>
              </div>

              <div className="career-paths">
                <p className="highlight-heading">Career Paths:</p>
                <p>• Cybersecurity Expert</p>
                <p>• Cloud Solutions Architect</p>
                <p>• Software Engineer</p>
                <p>• Data Analyst</p>
              </div>
            </div>

            <div className="financial-administration-specialization">
              <Link to="/Overview/66e82451ccd836f84801f23a/information-technology">
                <h3 className="subsection-title-h3 text-hover-blue-underline">
                  B.Tech in Information Technology
                </h3>
              </Link>
              <p className="specialization-description">
                This program equips students with essential skills in
                networking, application development, systems integration, and IT
                infrastructure. It prepares students to manage both hardware and
                software in modern organizations.
              </p>

              <div className="course-highlights">
                <p className="highlight-heading">Course Features:</p>
                <p>• Network & Infrastructure Management</p>
                <p>• Cloud Computing</p>
                <p>• Web & App Development</p>
                <p>• DevOps and IT Services</p>
              </div>

              <div className="career-paths">
                <p className="highlight-heading">Career Paths:</p>
                <p>• IT Analyst</p>
                <p>• System Administrator</p>
                <p>• Software Developer</p>
                <p>• Network Engineer</p>
              </div>
            </div>

            <div className="financial-administration-specialization ">
              <Link to="/Overview/66e91cacccd836f84801f59a/artificial-intelligence-and-data-science">
                <h3 className="subsection-title-h3 text-hover-blue-underline">
                  B.Tech in Artificial Intelligence & Data Science
                </h3>
              </Link>
              <p className="specialization-description">
                One of the most future-centric programs, this course is designed
                for students interested in data modeling, AI algorithms, and
                analytics. It includes Python, TensorFlow, data visualization,
                and real-time AI applications.
              </p>

              <div className="course-highlights">
                <p className="highlight-heading">Course Features:</p>
                <p>• Deep Learning & Neural Networks</p>
                <p>• Big Data Analytics</p>
                <p>• Python for AI</p>
                <p>• Real-Time AI Projects</p>
              </div>

              <div className="career-paths">
                <p className="highlight-heading">Career Paths:</p>

                <p>• AI/ML Engineer</p>
                <p>• Data Scientist</p>
                <p>• Business Intelligence Analyst</p>
                <p>• AI Software Developer</p>
              </div>
            </div>

            <div className="financial-administration-specialization">
              <Link to="/Overview/66e82a92ccd836f84801f2dd/department-of-electronics-and-communication">
                <h3 className="subsection-title-h3 text-hover-blue-underline">
                  B.Tech in Electronics & Communication Engineering
                </h3>
              </Link>

              <p className="specialization-description">
                ECE at CDGI covers analog and digital systems, VLSI design,
                embedded systems, IoT, and robotics. Students work on real-time
                circuit boards, sensors, and simulation tools.
              </p>

              <div className="course-highlights">
                <p className="highlight-heading">Course Features:</p>
                <p>• Signal Processing</p>
                <p>• Embedded Systems</p>
                <p>• IoT & Wireless Communication</p>
                <p>• VLSI & Microcontroller Programming</p>
              </div>

              <div className="career-paths">
                <p className="highlight-heading">Career Paths:</p>
                <p>• Embedded Systems Engineer</p>
                <p>• Communication Engineer</p>
                <p>• Hardware Developer</p>
                <p>• IoT Specialist</p>
              </div>
            </div>

            <div className="financial-administration-specialization">
              <Link to="/Overview/66e83053ccd836f84801f39c/department-of-mechanical-engineering">
                <h3 className="subsection-title-h3 text-hover-blue-underline">
                  B.Tech in Mechanical Engineering
                </h3>
              </Link>
              <p className="specialization-description">
                Mechanical Engineering at CDGI focuses on design, manufacturing,
                thermodynamics, CAD/CAM, and robotics. Our workshops and
                laboratories provide real-time exposure to industrial tools.
              </p>

              <div className="course-highlights">
                <p className="highlight-heading">Course Features:</p>
                <p>• 3D Modeling & CAD Tools</p>
                <p>• Thermodynamics & Heat Transfer</p>
                <p>• Fluid Mechanics</p>
                <p>• Manufacturing Processes</p>
              </div>

              <div className="career-paths">
                <p className="highlight-heading">Career Paths:</p>
                <p>• Design Engineer</p>
                <p>• Mechanical Systems Engineer</p>
                <p>• Production Engineer</p>
                <p>• R&D Engineer</p>
              </div>
            </div>

            <div className="financial-administration-specialization">
              <Link to="/Overview/66e91028ccd836f84801f4a3/department-of-civil-engineering">
                <h3 className="subsection-title-h3 text-hover-blue-underline">
                  B.Tech in Civil Engineering
                </h3>
              </Link>
              <p className="specialization-description">
                CDGI’s Civil Engineering program prepares students to build
                infrastructure with sustainable engineering practices. With
                modules in surveying, structural analysis, and project
                management, students gain core civil skills.
              </p>

              <div className="course-highlights">
                <p className="highlight-heading">Course Features:</p>
                <p>• Surveying & Geomatics</p>
                <p>• Structural Analysis</p>
                <p>• Building Construction</p>
                <p>• Estimation & Costing</p>
              </div>

              <div className="career-paths">
                <p className="highlight-heading">Career Paths:</p>
                <p>• Civil Engineer</p>
                <p> • Site Supervisor</p>
                <p> • Project Manager</p>
                <p> • Construction Consultant</p>
              </div>
            </div>
          </div>

          <div className="placements-container">
            <h2 className="section-title-h2">
              Placements at CDGI – Top Engineering Colleges in Indore
            </h2>
            <p className="section-description">
              CDGI has a strong reputation for placement success. Our Training
              and Placement Cell works closely with leading recruiters to ensure
              our students find rewarding career opportunities.
            </p>

            <div className="top-recruiters">
              <p className="highlight-heading">Top Recruiters:</p>

              <p> • TCS</p>
              <p> • Wipro</p>
              <p> • Infosys</p>
              <p> • Capgemini</p>
              <p> • Cognizant</p>
              <p> • L&T</p>
              <p> • Bosch</p>
            </div>

            <div className="placement-prep">
              <h2
                className="section-title-h2"
                style={{
                  marginTop: "30px",
                }}
              >
                Life at CDGI – A Complete Campus Experience
              </h2>
              <p className="section-description">
                At CDGI, education goes beyond the classroom. Our campus
                provides an environment that fosters creativity, leadership, and
                holistic growth.
              </p>

              <p className="campus-highlight">Campus Highlights: </p>
              <p
                style={{
                  marginTop: "10px",
                }}
              >
                • Wi-Fi Enabled Campus & Hostels
              </p>
              <p>• Technical & Cultural Clubs</p>
              <p>• Sports & Fitness Facilities</p>
              <p>• Annual Tech Fests & Hackathons</p>
              <p>• Guest Lectures from Industry Leaders</p>
            </div>
          </div>

          <div className="student-life-container">
            <h2 className="section-title-h2">
              Faculty at CDGI – Experts Who Inspire
            </h2>
            <p className="section-description">
              CDGI’s strength lies in its faculty—a blend of experienced
              academicians, PhD scholars, and industry professionals who are
              dedicated to student development.
            </p>

            <div className="campus-facilities">
              <p className="campus-highlight">Faculty Attributes:</p>
              <p>• Real-World Industry Exposure</p>
              <p>• Research Publications & Patents</p>
              <p>• National & International Conferences</p>
              <p>• Mentorship & Innovation Support</p>
            </div>
          </div>

          <div className="why-cdgi-standout-container">
            <h2 className="section-title-h2">
              CDGI – One of the Top Engineering Colleges in Indore
            </h2>

            <p>
              • As one of the top engineering colleges in Indore, CDGI continues
              to set benchmarks in student success, academic excellence, and
              professional development. Our engineering programs offer the
              perfect blend of knowledge, skills, and opportunities that align
              with current and future industry demands.
            </p>
          </div>

          <div className="admission-process-container">
            <h2 className="section-title-h2">
              Admission Process – Join CDGI in 2025-26
            </h2>

            <div className="eligibility-criteria">
              <h4 className="subsection-title-h4">Eligibility Criteria:</h4>
              <p>• Passed 10+2 with PCM (Physics, Chemistry, Mathematics)</p>
              <p>• Minimum aggregate as per AICTE/RGPV guidelines</p>
              <p>• Valid scores in JEE Main or state entrance exams</p>
            </div>

            <div className="steps-to-apply">
              <h4 className="subsection-title-h4">Steps to Apply:</h4>
              <p>
                • Click on{" "}
                  <span className="text-hover-blue-underline"
                  style={{
                    fontSize: "17px",
                    fontWeight: "500"
                  }}
                  onClick={openModal}
                  > Apply Now</span>
           
                for B.Tech Program
              </p>
            </div>
          </div>
        </>
      )}

      <div>
        <button
          style={{
            all: "unset",
            textAlign: "center",
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "0px",
            paddingBottom: "0px",
            borderRadius: "3px",
            backgroundColor: "#004b9c",
            color: "white",
            cursor: "pointer",
            marginTop: "10px",
          }}
          onClick={handleShowContent}
        >
          {showMoreContent ? "Read Less" : "Read More"}
        </button>
      </div>
    </div>
  );
};

export default Institute_Highlights;
